"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var smoothscroll_for_websites_1 = __importDefault(require("smoothscroll-for-websites"));
var smooth = function () {
    function isChrome() {
        var isChromium = window.chrome;
        var winNav = window.navigator;
        var vendorName = winNav.vendor;
        var isOpera = winNav.userAgent.indexOf('OPR') > -1;
        var isIEedge = winNav.userAgent.indexOf('Edge') > -1;
        var isIOSChrome = winNav.userAgent.match('CriOS');
        return isChromium !== null && isChromium !== undefined && vendorName === 'Google Inc.' && isOpera == false && isIEedge == false;
    }
    return !isChrome() && smoothscroll_for_websites_1.default.destroy();
};
exports.default = smooth;
